export * from './dict.module';
